import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { ObjectF } from "../models/formulas/object";
import { FilterObjectCatalog } from "../models/filters/filter-object-catalog";

@Injectable({
  providedIn: 'root'
})
export class ObjectCatalogService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/objectsCatalog'; 

  findAllPageableObjectCatalog(filterObjectCatalog: FilterObjectCatalog, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterObjectCatalog);
  }

  findObjectCatalogById(id: number): Observable<ObjectF> {
    return this.http.get<ObjectF>(`${this.url}/${id}`);
  }

  createObjectCatalog(object: ObjectF): Observable<ObjectF>{
    return this.http.post<ObjectF>(this.url, object);
  }

  updateObjectCatalog(object: ObjectF): Observable<ObjectF>{
    return this.http.put<ObjectF>(`${this.url}/${object.id}`, object);
  }

}